import { createAction, props } from '@ngrx/store';
import { IUploadedFile } from '../../interfaces/uploaded-file.interface';
import { IUploadFileForm } from '../../interfaces/upload-file-form.interface';
import {
    IUploadedFileWithUrl,
    IUploadPreview,
    IInformationManagement,
    IInformationLegal,
    IInformationLocation,
    IInformationTranslation
} from '@app-root-interfaces';

// File upload
export const addFiles = createAction('[Upload] Add files', props<{ files: IUploadedFile[] }>());

export const addFilesSuccess = createAction('[Upload] Add files success', props<{ files: IUploadedFile[] }>());

export const updateMultipleFiles = createAction('[Upload] Update multiple files', props<{ files: IUploadedFile[] }>());

export const setActiveFile = createAction('[Upload] Set active file', props<{ fileId: string }>());

export const updateUploadedFile = createAction('[Upload] Update uploaded file', props<{ values: IUploadFileForm }>());

export const updateUploadedFileSuccess = createAction(
    '[Upload] Update uploaded file success',
    props<{ values: IUploadedFile }>()
);

export const updatePreview = createAction('[Upload] Update preview', props<{ preview: IUploadPreview }>());

export const updatePreviewSuccess = createAction('[Upload] Update preview success', props<{ values: IUploadedFile }>());

export const startUploadingReadyFiles = createAction('[Upload] Start uploading ready files');

export const uploadingFilesSuccess = createAction('[Upload] Upload files success', props<{ values: IUploadedFile }>());

export const uploadingFilesFailure = createAction('[Upload] Upload files failure', props<{ values: IUploadedFile }>());

export const createSignedUrlForUpload = createAction(
    '[Upload] Create signed url for upload',
    props<{ file: IUploadedFile }>()
);

export const uploadFile = createAction('[Upload] Upload file', props<{ file: IUploadedFileWithUrl }>());

export const addFolder = createAction('[Upload] Add Folder', props<{ id: string }>());

export const addFolderSuccess = createAction('[Upload] Add Folder success', props<{ values: IUploadedFile }>());

export const addDrive = createAction('[Upload] Add Drive');

export const addDriveSuccess = createAction('[Upload] Add Drive success', props<{ values: IUploadedFile }>());

export const removeDrive = createAction('[Upload] Remove Drive');
export const removeDriveSuccess = createAction('[Upload] Remove Drive success', props<{ values: IUploadedFile }>());

export const removeFileFromUploadList = createAction(
    '[Upload] Remove file from upload list',
    props<{ values: IUploadedFile }>()
);

export const createSignedUrlForPreview = createAction(
    '[Upload] Create signed url for preview',
    props<{ file: IUploadedFile }>()
);

export const uploadPreview = createAction(
    '[Upload] Upload preview',
    props<{ file: IUploadedFile; signedUrl: string; locationUrl: string }>()
);

// Information Upload

export const uploadInformationManagement = createAction(
    '[Upload] Upload information management',
    props<{ files: File[] }>()
);
export const clearInformationManagement = createAction('[Upload] Clear information management');

export const uploadInformationManagementSuccess = createAction(
    '[Upload] Upload information management success',
    props<{ management: IInformationManagement[] }>()
);

export const uploadInformationLegals = createAction('[Upload] Upload information legals', props<{ files: File[] }>());
export const clearInformationLegals = createAction('[Upload] Clear information legals');

export const uploadInformationLegalsSuccess = createAction(
    '[Upload] Upload information legals success',
    props<{ legals: IInformationLegal[] }>()
);

export const uploadInformationLocations = createAction(
    '[Upload] Upload information locations',
    props<{ files: File[] }>()
);
export const clearInformationLocations = createAction('[Upload] Clear information locations');

export const uploadInformationLocationsSuccess = createAction(
    '[Upload] Upload information locations success',
    props<{ locations: IInformationLocation[] }>()
);

export const uploadInformationTranslations = createAction(
    '[Upload] Upload information translations',
    props<{ files: File[] }>()
);
export const clearInformationTranslations = createAction('[Upload] Clear information translations');

export const uploadInformationTranslationsSuccess = createAction(
    '[Upload] Upload information translations success',
    props<{ translations: IInformationTranslation[] }>()
);

export const submitManagementData = createAction('[Upload] Submit management data', props<{ file: File }>());

export const submitManagementDataSuccess = createAction('[Upload] Submit management data success');

export const submitManagementDataFailure = createAction('[Upload] Submit management data failure');

export const submitLegalData = createAction('[Upload] Submit legal data', props<{ file: File }>());

export const submitLegalDataSuccess = createAction('[Upload] Submit legal data success');

export const submitLegalDataFailure = createAction('[Upload] Submit legal data failure');

export const submitLocationData = createAction('[Upload] Submit location data', props<{ file: File }>());

export const submitLocationDataSuccess = createAction('[Upload] Submit location data success');

export const submitLocationDataFailure = createAction('[Upload] Submit location data failure');

export const submitTranslationData = createAction('[Upload] Submit translation data', props<{ file: File }>());

export const submitTranslationDataSuccess = createAction('[Upload] Submit translation data success');

export const submitTranslationDataFailure = createAction('[Upload] Submit translation data failure');
